/**
 * axios封装
 * 请求拦截、响应拦截、错误统一处理
 */
import axios from "axios";
import router from "../router";
import store from "../store/index";
import { Message } from "element-ui";
import base from "./base";
import { auth } from "../utils/authPatch";

const toLogin = () => {
  router.push({
    name: "login",
    query: {
      centerId: localStorage.getItem("centerId"),
    },
  });
};

/**
 * 请求失败后的错误统一处理
 * @param {Number} status 请求失败的状态码
 */
const errorHandle = (data, errType) => {
  Message.closeAll();
  let status;
  let message;
  status = data.code;
  message = data.msg;
  // 状态码判断
  switch (status) {
    // case -1:
    //   Message(message + ", 请重新下单");
    //   store.commit("userLogout");
    //   toLogin();
    //   break;
    // 401: 登录过期
    case 401:
      Message("请重新登录");
      store.commit("userLogout");
      toLogin();
      break;
    case 404:
      // tip('请求资源不存在');
      break;
    default:
      if (message) {
        Message.warning(message);
      }
  }
};

var instance = axios.create({ timeout: 1000 * 12 });
instance.defaults.headers.post["Content-Type"] =
  "application/x-www-form-urlencoded";
/**
 * 请求拦截器
 * 每次请求前，如果存在token则在请求头中携带token
 */
instance.interceptors.request.use(
  (config) => {
    // if (process.env.NODE_ENV == 'development') {
    //   console.log("request", config)
    // }
    const token = store.state.token;
    let requestUrl = config.url.replace(base.baseURL, "");
    if (token && !auth(requestUrl)) {
      config.headers.Authorization = "Bearer " + token;
    } else {
      config.headers.Authorization = base.baseAuth;
    }
    return config;
  },
  (error) => Promise.error(error)
);
// 响应拦截器
instance.interceptors.response.use(
  (res) => {
    if (res.data.code === 0) {
      // 分页类型数据
      return Promise.resolve(res.data);
    } else {
      if (res.data.code !== 0) {
        // 一般类型数据
        errorHandle(res.data, "IFSErr");
      }

      return res.data.code === 0
        ? Promise.resolve(res.data)
        : Promise.reject(res.data);
    }
  },
  (error) => {
    const { response } = error;
    console.log('response', response);
    if (response) {
      if (response.status === 401) {
        switch (response.status) {
          // 401: 登录过期
          case 401:
            if (!response.config.url.includes('/api/account/status')) {
              Message("访问未操作时间过长, 请重新操作");
              store.commit("userLogout");
              toLogin();
            } else {
              return Promise.resolve(response.data)
            }
            break;
          case 404:
            break;
          default:
            if (message) {
              Message.warning(message);
            }
        }
        return;
      }
      // 请求已发出，但是不在2xx的范围
      errorHandle(response.data, "REQErr");
      return Promise.reject(response);
    } else {
      Message("网络异常，请稍后再试");
    }
  }
);
export default instance;



// WEBPACK FOOTER //
// ./src/request/http.js